import { APIS } from '../../utils/api-factory'
import LocalStore from '../../utils/localStorageUtil'
import Route from '../../Layout/Routes'
import { STRING } from '../../utils/Constant'
import history from '../../utils/history';

export const validateToken = (res) => {
    if (res.code !== undefined) {
        if (res.code === STRING.TOKEN_NOT_VALID) {
            return false
        } else {
            return true
        }
    } else {
        return true
    }
}

export const autoSuggestApi = (tabType, type, value, callBack, error) => {
    fetch(APIS.AUTO_SUGGEST + tabType + '/' + type + '/' + value, {
        method: 'get',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}

export const tableDataApi = (data, tabValue, offset, callBack, error) => {
    fetch(APIS.TABLE_DATA + tabValue.toLowerCase() + '/' + offset + '/', {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        })
        .catch(e => {
            error(e)
        })
}

export const heirarchyListApi = (callBack, error) => {
    fetch(APIS.HEIRARCHY_LIST, {
        method: 'get',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}

export const getSectorListApi = (callBack, error) => {
    fetch(APIS.GET_SECTOR)
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const getInvestorListApi = (value, callBack, error) => {
    fetch(APIS.GET_INVESTOR + value)
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const getUserIdApi = (callBack, error) => {
    fetch(APIS.GET_USERID, {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    })
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const changePasswordApi = (changePasswordData, callBack, error) => {
    const data = {
        old_password: changePasswordData.oldPassword,
        password: changePasswordData.newPassword,
        password2: changePasswordData.confirmPassword
    }
    fetch(APIS.CHANGE_PASSWORD + LocalStore.getFromLocalStorage('loginUserId') + '/', {
        method: 'put',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const loginUserApi = (loginData, callBack, error) => {
    var data = {
        username: loginData.email,
        password: loginData.password
    }
    fetch(APIS.LOGIN_USER, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            callBack(res)
        })
        .catch(e => {
            error(e)
        })
}

export const logoutApi = () => {
    let data = {
        refresh_token: LocalStore.getFromLocalStorage('refresh_token')
    }
    fetch(APIS.LOGOUT_USER, {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.text())
        .then(res => {
            LocalStore.deleteFromLocalStorage('access_token')
            LocalStore.deleteFromLocalStorage('refresh_token')
            LocalStore.deleteFromLocalStorage('loginUser')
            LocalStore.deleteFromLocalStorage('loginPassword')
            history.push(Route.LOGIN)
            window.location.reload();
        }).catch(e => {

        })
}

export const registerUserApi = (loginData, callBack, error) => {
    var data = {
        email: loginData.email,
        username: loginData.userName,
        password: loginData.password
    }
    fetch(APIS.REGISTER_USER, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            callBack(res)
        })
        .catch(e => {
            error(e)
        })
}

export const testApi = (callBack, error) => {
    fetch(APIS.TEST_API, {
        method: 'get',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}

export const getCountApi = (tabName, filter, callBack, error) => {
    fetch(APIS.TABLE_DATA + tabName.toLowerCase() + '/count/', {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(filter)
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}

export const sortTableApi = (tabName, columnName, sortValue, offSet, filter, callBack, error) => {
    fetch(APIS.TABLE_DATA + tabName.toLowerCase() + '/sort/' + columnName + '/' + sortValue + '/' + offSet + '/', {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(filter)
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })

}

export const globalSearchApi = (val, callBack, error) => {
    const data = {
        userinput: [val]
    }
    fetch(APIS.GLOBAL_SEARCH, {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const entityPopupDataApi = (entity, entityName, callBack, error) => {
    fetch(APIS.GET_ENTITY_POPUP_DATA + entity.toLowerCase() + '/' + entityName + '/')
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const profileDataApi = (tabName, entityName, year, callBack, error) => {
    var url = '';
    if (tabName !== null && tabName !== '') {
        url += tabName;
    }
    if (entityName !== null && entityName !== '') {
        url += '/' + entityName;
    }
    if (year !== null && year !== '') {
        url += '/' + year;
    }

    fetch(APIS.PROFILE + url)
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const downloadExcelNdCsvApi = (collist, filter, sort, entity, dwnldType, pageNumber, callBack, error) => {
    let data = {
        collist: collist,
        filterlist: filter,
        sortlist: sort.name,
        sorttype: sort.orderBy

    }
    fetch(APIS.DOWNLOAD_EXCEL + entity + '/' + dwnldType + '/' + pageNumber + '/', {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.blob())
        .then(blob => {
            callBack(blob)
        }).catch(e => {
            error(e)
        })
}

export const newsAndSignalDataApi = (type, requestBody, callBack, error) => {
    if (type === "news") {
        fetch(APIS.FETCH_NEWS, {
            method: 'post',
            body: JSON.stringify(requestBody)
        })
            .then(res => res.json())
            .then(res => {
                callBack(res)
            })
            .catch(e => {
                error(e)
            })
    } else {
        fetch(APIS.FETCH_SIGNAL, {
            method: 'post',
            body: JSON.stringify(requestBody)
        })
            .then(res => res.json())
            .then(res => {
                callBack(res)
            })
            .catch(e => {
                error(e)
            })
    }
}

export const stackDataDataApi = (sectorName, callBack, error) => {
    let secName = ''
    secName = sectorName.replace(/&/g, '%26')
    return dispatch => {
        fetch(APIS.GET_STACK_VIEW + secName + '&industries=')
            .then(res => res.json())
            .then(res => {
                callBack(res)
                dispatch({ type: "STACK_DATA", stackData: res });
            }).catch(e => {
                error(e)
            })
    }
}

export const companyProfileDataApi = (permalink, callBack, error) => {
    fetch(APIS.COMPANY_PROFILE + permalink)
        .then(res => res.json())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const getComparablesApi = (permalink, callBack, error) => {
    fetch(APIS.GET_COMPARABLES + permalink, {
        method: 'get',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}

export const updateStackProcessingApi = (stackData, callBack, error) => {
    let data = stackData.map(function (item) {
        return {
            locX: item.locX,
            locY: item.locY,
            sizeX: item.sizeX,
            sizeY: item.sizeY,
            themeId: item.themeId,
            sectorLabel: item.sectorLabel,
            themeType: item.themeType,
            orientation: item.orientation,
            tOrder: item.order,
            parentId: item.parentId,
            label: item.label,
        }
    })
    fetch(APIS.UPDATE_STACK_PROCESSING, {
        method: 'post',
        headers: {
            // 'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.text())
        .then(res => {
            callBack(res)
        }).catch(e => {
            error(e)
        })
}

export const acrossIndustrytableDataApi = (data, sortByColumn, tabValue, offset, callBack, error) => {
    let api = ''
    if(sortByColumn.name !== ''){
        api = APIS.TABLE_DATA + tabValue + '/sort/' + sortByColumn.name + '/' + sortByColumn.orderBy + '/' + offset + '/'
    } else {
        api = APIS.TABLE_DATA + tabValue + '/' + offset + '/'
    }
    fetch(api, {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        })
        .catch(e => {
            error(e)
        })
}

export const getAcrossIndustryCountApi = (tabName, filter, callBack, error) => {
    fetch(APIS.TABLE_DATA + tabName.toLowerCase() + '/count/', {
        method: 'post',
        headers: {
            'Authorization': "JWT " + LocalStore.getFromLocalStorage('access_token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(filter)
    })
        .then(res => res.json())
        .then(res => {
            if (validateToken(res)) {
                callBack(res)
            } else {
                logoutApi()
            }
        }).catch(e => {
            error(e)
        })
}